<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Dashboard</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <b style="font-size: 1.5em">Balance SMS: {{ balance }}</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <!-- Takaful Brunei -->
    <h3 style="color: #78be20; margin-bottom: 20px">Takaful Brunei</h3>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <!-- <button @click="clickme(index)">clickme</button> -->
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #78be20">Registered Users</h3>

            <br />

            <div class="row">
              <div class="col">
                <!-- Pending Verification -->
                <h5 class="mb-2 text-muted">Pending</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ customers.pending }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>

              <div class="col">
                <!-- Verified -->
                <h5 class="mb-2 text-muted">Verified</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ customers.verified }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
              <!-- Declined Verification -->

              <!-- <div class="col">
                <h5 class="mb-2 text-muted">Declined</h5>
                <p
                  class="mb-1 text-30 font-weight-light"
                  style="color: #ac8400"
                >
                  {{ customers.declined }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div
                    class="progress-bar bg-success"
                    style="width: 100%"
                    role="progressbar"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div> -->

              <div class="col">
                <!-- Total -->
                <h5 class="mb-2 text-muted">Total</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ customers.all }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>

              <div class="col">
                <!-- Deleted -->
                <h5 class="mb-2 text-muted">Deleted</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ customers.deleted }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <!-- <button @click="clickme(index)">clickme</button> -->
        <div class="card mb-4">
          <div class="card-body">
            <!-- Title -->
            <h3 style="color: #78be20">Purchases</h3>

            <br />

            <div class="row">
              <div class="col" v-if="
                roles.includes('Administrator') || roles.includes('TBA Staff')
              ">
                <h5 class="mb-2 text-muted">TBA</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tba.purchases }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>

              <div class="col" v-if="
                roles.includes('Administrator') || roles.includes('TBK Staff')
              ">
                <h5 class="mb-2 text-muted">TBK</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tbk.purchases }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Takaful Brunei -->

    <div class="row">
      <div class="col-lg-4 col-md-6 col-12" v-if="roles.includes('Administrator') || roles.includes('TBA Staff')">
        <!-- TBA -->
        <div class="row">
          <div class="col">
            <!-- <button @click="clickme(index)">clickme</button> -->
            <div class="card mb-4">
              <div class="card-body">
                <!-- Title -->
                <h3 style="color: #78be20">{{ tba.title }}</h3>

                <br />

                <!-- New -->
                <h5 class="mb-2 text-muted">New</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tba.claims.new }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <br />

                <!-- In Process -->
                <h5 class="mb-2 text-muted">In Process</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tba.claims.in_process }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <br />

                <!-- Approved -->
                <h5 class="mb-2 text-muted">Approved</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tba.claims.approved }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <br />

                <!-- Rejected -->
                <h5 class="mb-2 text-muted">Rejected</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tba.claims.rejected }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12" v-if="roles.includes('Administrator') || roles.includes('TBK Staff')">
        <!-- TBK -->
        <!-- <h3 style="color: #78BE20; margin-bottom: 20px;">Takaful Brunei Keluarga (TBK)</h3> -->
        <div class="row">
          <div class="col">
            <!-- <button @click="clickme(index)">clickme</button> -->
            <div class="card mb-4">
              <div class="card-body">
                <!-- Title -->
                <h3 style="color: #78be20">{{ tbk.title }}</h3>

                <br />

                <!-- New -->
                <h5 class="mb-2 text-muted">New</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tbk.claims.new }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <br />

                <!-- In Process -->
                <h5 class="mb-2 text-muted">In Process</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tbk.claims.in_process }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <br />

                <!-- Completed -->
                <h5 class="mb-2 text-muted">Approved</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tbk.claims.approved }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>

                <br />

                <!-- Rejected -->
                <h5 class="mb-2 text-muted">Rejected</h5>
                <p class="mb-1 text-30 font-weight-light" style="color: #ac8400">
                  {{ tbk.claims.rejected }}
                </p>
                <div class="progress mb-1" style="height: 4px">
                  <div class="progress-bar bg-success" style="width: 100%" role="progressbar" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "dashboard",

  components: {},

  data() {
    return {
      roles: [],
      balance: 0,
      user: {},
      tba: {
        title: "Claim TBA",
        purchases: 0,
        claims: {
          new: 0,
          in_process: 0,
          approved: 0,
          rejected: 0,
        },
      },
      tbk: {
        title: "Claim TBK",
        purchases: 0,
        claims: {
          new: 0,
          in_process: 0,
          approved: 0,
          rejected: 0,
        },
      },
      customers: {
        verified: 0,
        pending: 0,
        declined: 0,
        all: 0,
        deleted: 0,
      },
    };
  },

  methods: {
    loadUser() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      axios
        .get("/auth/user", {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          this.user = res.data;
        })
        .catch((err) => {
          this.$router.push("/login");
          localStorage.clear();
        });
    },

    loadSmsBalance() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/sms", {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.balance = res.data.balance;
          })
          .catch((err) => {
            // this.$router.push("/login");
            // localStorage.clear();
          });
      }
    },

    loadStatistic() {
      let token = localStorage.getItem("token");

      if (token == null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      axios
        .get("/statistics/dashboard", {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          const { verified, pending, declined, all, deleted } =
            res.data.customers;
          const { tba, tbk } = res.data;

          this.customers.verified = verified;
          this.customers.pending = pending;
          this.customers.declined = declined;
          this.customers.all = all;
          this.customers.deleted = deleted;

          this.tba.purchases = tba.purchases;
          this.tba.claims.new = tba.claims.new;
          this.tba.claims.in_process = tba.claims.in_process;
          this.tba.claims.approved = tba.claims.approved;
          this.tba.claims.rejected = tba.claims.rejected;

          this.tbk.purchases = tbk.purchases;
          this.tbk.claims.new = tbk.claims.new;
          this.tbk.claims.in_process = tbk.claims.in_process;
          this.tbk.claims.approved = tbk.claims.approved;
          this.tbk.claims.rejected = tbk.claims.rejected;
        });
    },

    loadRoles() {
      let user = localStorage.getItem("user");
      user = JSON.parse(user);
      this.roles = user.roles.map((role) => role.name);
    },
  },

  mounted() {
    this.loadUser();
    this.loadRoles();
    this.loadStatistic();
    this.loadSmsBalance();
  },
};
</script>
